//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import cityJson from './city.json'

export default {
    props: {
        value: {
            type: String,
            default: ''
        },
        disabled: {
            type: Boolean,
            default: false
        },
        placeholder: {
            type: String,
            default: ''
        },
        size: {
            type: String,
            default: ''
        },
        changeOnSelect: {
            type: Boolean,
            default: true
        },
        props: {
            type: Object,
            default: function() {
                return {
                    value: 'citycode',
                    label: 'cityname',
                    children: 'children',
                    disabled: 'disabled'
                }
            }
        }
    },
    data: function () {
        return {
            NodeData: [],
            item: {},
            map: {}
        }
    },
    created: function () {
        var that = this;

        that.NodeData = arrBuildTree(cityJson, 'parentcode', 'citycode');

        cityJson.forEach(function(item) {
            that.map[item[that.props.value]] = item;
        });
    },
    computed: {
        bindData: {
            get: function () {
                var parentList = [];
                if (!IsNullOrEmpty(this.value)) {
                    this.GetParent(this.value, this.NodeData, parentList);
                }
                parentList = parentList.reverse();
                this.stop = false;
                return parentList;
            },
            set: function (val) {
                var that = this,
                    value = val.length > 0 ? val[val.length - 1] : "",
                    fullName = '';

                val.forEach(function(item, index) {
                    fullName += ('-' + that.map[item]['cityname']);
                });
                this.$emit("input", value);
                this.$emit('update:cityname', fullName.substring(1));
            }
        }
    },
    methods: {
        GetParent: function (value, list, parentList) { //获取父级节点
            var that = this;

            $.each(list, function (i) {
                if (this[that.props.children]) {
                    if (this[that.props.value] == value) {
                        that.stop = true;
                        parentList.push(this[that.props.value]);
                    } else {
                        that.GetParent(value, this[that.props.children], parentList)
                    }

                    if (that.stop) {
                        parentList.push(this[that.props.value]);
                        return false;
                    }
                } else {
                    if (this[that.props.value] == value) {
                        that.stop = true;
                        parentList.push(this[that.props.value]);
                        return false;
                    }
                }
            })
        },
        changeHandler(e) {
            e.forEach((item, index) => {
                this.$emit('update:l' + index + 'value', item);
                this.$emit('update:l' + index + 'label', this.map[item][this.props.label]);
            })
        }
    }
}
